import {
  DEMAND_TYPES_LOADED,
  DEMAND_TYPE_ADDED,
  DEMAND_TYPE_SAVED,
  DEMAND_TYPE_DELETED,
  getByIdDecorator,
} from '../constants/AppConstants';

const initialState = getByIdDecorator([]);
initialState.showNew = false;

export default function (state = initialState, action) {
  switch (action.type) {
    case DEMAND_TYPES_LOADED: {
      const newState = [...action.list];
      newState.showNew = state.showNew;
      return getByIdDecorator(newState);
    }
    case DEMAND_TYPE_ADDED: {
      const newState = [...state];
      newState.showNew = true;
      return getByIdDecorator(newState);
    }
    case DEMAND_TYPE_SAVED: {
      if (action.creation) {
        return getByIdDecorator([...state, action.item]);
      }
      const newState = state.map((demandType) => (demandType.id === action.item.id ? action.item : demandType));
      newState.showNew = state.showNew;
      return getByIdDecorator(newState);
    }
    case DEMAND_TYPE_DELETED: {
      if (!action.id) {
        return getByIdDecorator([...state]);
      }
      const newState = state.filter((demandType) => demandType.id !== action.id);
      newState.showNew = state.showNew;
      return getByIdDecorator(newState);
    }
    default:
      return state;
  }
}
